import { initTrustArcPlaceholder } from '@/utils/trustArc/trustArcPlaceholder';

// Module scripts are deferred, so this runs after the markup is parsed but well before
// the TrustArc banner initializes, without blocking the initial render.
initTrustArcPlaceholder();
